import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Import\StartImportTaskController::__invoke
* @see app/Http/Controllers/Import/StartImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/start'
*/
const StartImportTaskController = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: StartImportTaskController.url(args, options),
    method: 'get',
})

StartImportTaskController.definition = {
    methods: ["get","head"],
    url: '/api/import/{import}/task/{importTask}/start',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Import\StartImportTaskController::__invoke
* @see app/Http/Controllers/Import/StartImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/start'
*/
StartImportTaskController.url = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            import: args[0],
            importTask: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        import: args.import,
        importTask: typeof args.importTask === 'object'
        ? args.importTask.id
        : args.importTask,
    }

    return StartImportTaskController.definition.url
            .replace('{import}', parsedArgs.import.toString())
            .replace('{importTask}', parsedArgs.importTask.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Import\StartImportTaskController::__invoke
* @see app/Http/Controllers/Import/StartImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/start'
*/
StartImportTaskController.get = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: StartImportTaskController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Import\StartImportTaskController::__invoke
* @see app/Http/Controllers/Import/StartImportTaskController.php
* @route '/api/import/{import}/task/{importTask}/start'
*/
StartImportTaskController.head = (args: { import: string | number, importTask: string | number | { id: string | number } } | [importParam: string | number, importTask: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: StartImportTaskController.url(args, options),
    method: 'head',
})

export default StartImportTaskController